import { Component, OnInit } from '@angular/core';
import { PRIVACY_POLICY } from '@app/member-response-portal/model/constants';
import { Helper } from '@rawlings/core';

@Component({
  selector: 'app-footer-privacy-policy',
  templateUrl: './footer-privacy-policy.component.html',
  styleUrls: ['./footer-privacy-policy.component.scss'],
})
export class FooterPrivacyPolicyComponent implements OnInit {
    //#region Public Variables
    public PrivacyPolicyHTML: string = ''
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    private urlLearnMorePage : string = 'https://www.rawlingsgroup.com/';
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods

    public ngOnInit(): void {
        // eslint-disable-next-line @typescript-eslint/typedef
        const cachePolicy = localStorage.getItem(PRIVACY_POLICY);

        if (!Helper.IsEmpty(cachePolicy)){
            this.PrivacyPolicyHTML = cachePolicy;
        }
    }
    public OnClickLearnMore(): void {
        window.open(this.urlLearnMorePage);
    }
    //#endregion Public Methods
}
